import React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";
import { RendererProps } from "../BaseRenderer";
import useStyle from "./ImageAreaSelectionRenderer.styles";

interface Props extends RendererProps {
    onSelect?(): void;
    selected?: boolean;
    top: string;
    left: string;
    width: string;
    height: string;
    color: string;
    text: string;
    variableName?: string;
    areaCode?: string;
}

export default function ImageAreaSelectionRenderer(props: Props) {
    const divRef = React.useRef();
    const { text, selected, onSelect, variableName } = props;
    const theme = useTheme();
    const classes = useStyle({ theme });

    // Style-specific props
    const { top, left, width, height, color, areaCode } = props;
    const style = {
        top: top || "0px",
        left: left || "0px",
        width,
        height,
        backgroundColor: selected ? color : null,
    };

    const [active, setActive] = React.useState(false);

    return (
        <div
            id={variableName}
            data-areacode={areaCode}
            ref={divRef}
            role="checkbox"
            aria-checked={selected}
            tabIndex={0}
            aria-label={text}
            className={classnames(
                classes.imageAreaSelection,
                active && classes.imageAreaSelectionActive,
                selected && classes.imageAreaSelectionSelected,
            )}
            onKeyDown={(event) => {
                if (event.target !== divRef.current) return;
                if (event.key === " ") {
                    onSelect();
                    event.preventDefault();
                }
            }}
            onMouseDown={(event) => {
                onSelect();
                event.preventDefault();
            }}
            onFocus={() => setActive(true)}
            onBlur={() => setActive(false)}
            onMouseOver={() => setActive(true)}
            onMouseOut={() => setActive(false)}
            style={style}
            title={text}
        />
    );
}
